import endpoints from './endpoints';
import request from './request';

const customerApi = {
    initialize(companyId) {
        return request.get(
            endpoints.customer.initialize(companyId),
        );
    },

    upload(companyId, formData) {
        return request.postFile(
            endpoints.customer.upload(companyId),
            formData,
        );
    },

    generate(companyId, data) {
        return request.post(
            endpoints.customer.generate(companyId),
            data,
        );
    },

    generateExcel(companyId, formData) {
        return request.postFile(
            endpoints.customer.generateExcel(companyId),
            formData,
        );
    },

    download(companyId, fileName) {
        return request.download(
            endpoints.customer.download(companyId),
            {
                name: fileName,
            },
        );
    },

    downloadUrl(companyId) {
        return endpoints.customer.download(companyId).replace(/^\/+/, '');
    },
};

export default customerApi;


// WEBPACK FOOTER //
// ./src/api/customerApi.js